import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteContact } from './actions';
import { getContacts } from './reducer';
import { hasMutation } from './utils';

class ContactList extends Component {
  deleteContact = id => {
    this.props.deleteContact(id, 'cs');
  };

  renderTable = () => {
    const { contacts } = this.props;

    return contacts.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>{hasCs ? item.title.cs : hasEn ? item.title.en : ''}</td>
          <td>
            <Link
              to={{
                pathname: hasCs
                  ? `/kontakt/edit/${item.id}/cs`
                  : `/kontakt/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn
                  ? `/kontakt/edit/${item.id}/en`
                  : `/kontakt/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { contacts } = this.props;

    if (contacts.length === 0) {
      return <div>Kontaktní stránka neexistuje</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Název</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    contacts: getContacts(state)
  };
};

export default connect(
  mapStateToProps,
  { deleteContact }
)(ContactList);



// WEBPACK FOOTER //
// ./src/modules/ContactList/index.js